import React from 'react';
import Popup from 'reactjs-popup';
import { Typography } from '@mui/material';
import "./WarningPopup.css";

let WarningPopUp = ({ trigger, popUpTitle, handelSubmit, isBtnLoading }) => (
    <Popup
        trigger={trigger}
        modal
    >
        {(close) => {
            return (
                <div className="warning_popup">
                    <div className='wpu_div'>
                        <Typography variant="h4" sx={{ margin: "2rem 0rem 5rem 0" }}>
                            {popUpTitle}
                        </Typography>

                        <div style={{
                            display: "flex", justifyContent: "center",
                            marginBottom: "2rem"
                        }}>
                            <div className="wpu_btn wpu_yes_btn"
                                onClick={handelSubmit}>
                                {isBtnLoading ? "Loading..." : "Yes"}
                            </div>
                            <div className="wpu_btn wpu_close_btn"
                                onClick={async () => {
                                    close();
                                }}
                            >
                                Close
                            </div>
                        </div>
                    </div>
                </div>
            );
        }}
    </Popup>
);

export default WarningPopUp;